import { getApi, postApi } from "./api";

export const isMobileExist = async (mobileNo) => {
    return await getApi(
        `/Auth/IsMobileExist/${mobileNo}`
    );
};
export const IsEmailExist = async (mobileNo) => {
    return await getApi(
        `/Auth/IsEmailExist/${mobileNo}`
    );
};

export const loginUser = async (loginData) => {
    try {
        const response = await postApi(
            "/Auth/Login",
            loginData
        );

        return response;

    } catch (error) {

        throw error.response?.data || error.message;
    }
};
export const VerifyOtp = async (data) => {
    return await postApi("/Auth/VerifyOtp", data);
};
